import {
  Alert,
  Box,
  Button,
  Drawer,
  Grid,
  Icon,
  Stack,
  Typography,
} from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useQuery } from '@tanstack/react-query'
import { taxisAPI } from '../../../../../api/vehicle/taxisAPI'
import { useSupplierState } from '../../../../../Pages/Supplier/SupplierContext'
import CreateAdditionalCharge from './CreateAdditionalCharge'
import ViewAdditionalCharge from './ViewAdditionalCharge'

interface ComponentProps {
  taxiId: number | undefined
  isEdit: boolean
}
const AdditionalChargesComponent: FC<ComponentProps> = (props) => {
  const formMethods = useFormContext()
  const { chargeExceptions } = useSupplierState()
  const { taxiId, isEdit } = props

  const { data: existingAdditionalChargesData, isSuccess } = useQuery({
    queryKey: ['getAdditionalChargesByTaxiId', taxiId],
    queryFn: async () => taxisAPI.getAdditionalChargesByTaxiId(taxiId),
    enabled: !!taxiId,
    refetchOnWindowFocus: false,
  })

  const [additionalCharges, setAdditionalCharges] = useState<any[]>([])
  const [drawerVisible, setDrawerVisible] = useState(false)

  const CreateButton = () => {
    if (chargeExceptions.length === 0) {
      return (
        <Grid item>
          <Typography variant="body1" gutterBottom>
            No additional charges available.
          </Typography>
        </Grid>
      )
    }
    if (!isEdit) {
      return null
    }
    return (
      <Grid item>
        <Button
          variant="contained"
          endIcon={<Icon>add</Icon>}
          onClick={() => {
            setDrawerVisible(true)
          }}
        >
          Add additional charge
        </Button>
      </Grid>
    )
  }

  useEffect(() => {
    if (isSuccess && existingAdditionalChargesData?.data?.value) {
      setAdditionalCharges(existingAdditionalChargesData.data.value)
    }
  }, [isSuccess])

  useEffect(() => {
    if (additionalCharges) {
      formMethods.setValue('additionalCharges', additionalCharges)
      formMethods.setValue('vehicle-additionalCharges', [])
    }
  }, [additionalCharges])

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {additionalCharges.length === 0 && (
        <Alert severity="info">No additional charges have been set</Alert>
      )}
      <Box>
        <Grid container spacing={4} direction="row">
          <CreateButton />
        </Grid>
      </Box>
      {chargeExceptions && (
        <Drawer
          anchor={'right'}
          open={drawerVisible}
          onClose={() => {
            formMethods.unregister('vehicle-additionalCharges')
            setDrawerVisible(false)
          }}
        >
          <CreateAdditionalCharge
            options={chargeExceptions}
            index={additionalCharges.length}
            isEdit={isEdit}
            setDrawerVisible={setDrawerVisible}
            additionalCharges={additionalCharges}
            setAdditionalCharges={setAdditionalCharges}
          />
        </Drawer>
      )}

      {additionalCharges.map((charge, i) => (
        <ViewAdditionalCharge
          key={`${i}_${charge}`}
          index={i}
          chargeExceptions={chargeExceptions}
          additionalCharge={charge}
          isEdit={isEdit}
          additionalCharges={additionalCharges}
          setAdditionalCharges={setAdditionalCharges}
        />
      ))}
    </Stack>
  )
}
export default AdditionalChargesComponent
